import React from 'react'
import Image, { type StaticImageData } from 'next/image'
import weightLossImage from '@/assets/images/refresh/featured-category/weight-loss.jpg'
import inPersonImage from '@/assets/images/refresh/featured-category/in-person.jpg'
import dermatologyImage from '@/assets/images/refresh/featured-category/dermatology.jpg'
import musculoskeletalImage from '@/assets/images/refresh/featured-category/musculoskeletal.jpg'
import medicationsImage from '@/assets/images/refresh/featured-category/medications.jpg'
import everydayCareImage from '@/assets/images/refresh/featured-category/everyday-care.jpg'
import labTestsImage from '@/assets/images/refresh/featured-category/lab-tests.jpg'
import coldAndFluImage from '@/assets/images/refresh/featured-category/cold-and-flu.jpg'
import specialistReviewsImage from '@/assets/images/refresh/featured-category/specialist-review.jpg'
import classes from './Background.module.css'

export type BackgroundKey =
    | 'weight-loss'
    | 'in-person'
    | 'dermatology'
    | 'musculoskeletal'
    | 'medications'
    | 'everyday-care'
    | 'lab-tests'
    | 'cold-and-flu'
    | 'specialist-reviews'

/** `specialist-reviews` is the API/background key; the asset file is specialist-review.jpg. */
const BACKGROUND_IMAGES: Record<BackgroundKey, StaticImageData> = {
    'weight-loss': weightLossImage,
    'in-person': inPersonImage,
    dermatology: dermatologyImage,
    musculoskeletal: musculoskeletalImage,
    medications: medicationsImage,
    'everyday-care': everydayCareImage,
    'lab-tests': labTestsImage,
    'cold-and-flu': coldAndFluImage,
    'specialist-reviews': specialistReviewsImage,
}

interface BackgroundProps {
    background: BackgroundKey
    /** Eager-load the first above-fold card background (likely LCP). */
    priority?: boolean
}

export default function Background({ background, priority = false }: BackgroundProps) {
    const src = BACKGROUND_IMAGES[background]
    if (src == null) return null

    return (
        <div className={classes.root} aria-hidden>
            <Image
                src={src}
                alt=""
                fill
                sizes="(max-width: 48em) 100vw, 900px"
                className={classes.image}
                priority={priority}
                fetchPriority={priority ? 'high' : 'auto'}
                loading={priority ? 'eager' : 'lazy'}
                decoding="async"
            />
        </div>
    )
}
